import React, { useState, useEffect } from 'react';
import { Container, Alert, Button, Row, Col } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import { DataManager } from '../../../core/data-manager';
import moment from 'moment';
import { LoginManager } from '../../../core/login-manager';
import { useNavigate } from 'react-router-dom';


export default function LivePlayer({ episode }) {

    const [data, setData] = useState(null);
    const [errors, setErrors] = useState('');
    const userInfo = LoginManager.getUserInfo();
    const [started, setStarted] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        init()
    }, [episode]);


    async function init() {
        if (episode && episode.idLive) {
            var response = await DataManager.getItem('episode_live', episode.idLive)
            console.warn('episode_live', response)
            if (response.success === 1) {
                let b = response.body[0]
                console.log(b)
                setData(b)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
            }
        }
    }

    async function goToMeeting(item) {
        //navigate('/zoom/' + episode.id)
        window.location.href = '/zoom/' + episode.id

    }



    if (data !== null) {
        if (moment() > moment(data.startDatetime).add(-15, 'minutes') && moment() < moment(data.endDatetime).add(30, 'minutes')) {
            /* metting a cui si può partecipare */
            var meetingCase = 'allowed'
        }
        else {
            if (moment() > moment(data.endDatetime).add(30, 'minutes')) {
                /* meeting finito */
                var meetingCase = 'expired'
            }
            else {
                /* meeting ancora da iniziare */
                var meetingCase = 'wait'
            }
        }

        return (
            <>
                {errors.length > 0 &&
                    <Alert variant='danger mt-5'>
                        {errors}
                    </Alert>
                }


                {started === false ? (
                    <Container className='p-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                        <h4>Informazioni sul Meeting</h4>
                        <p className='lead'>{episode.name}</p>
                        <p className='text-secondary'>
                            <span className='fst-italic'>{moment(data.startDatetime).format("DD-MM-YYYY")}</span><br />
                            <span className='fst-italic'>{moment(data.startDatetime).format("HH:mm")} - {moment(data.endDatetime).format("HH:mm")}</span>
                        </p>
                        {meetingCase === 'expired' &&
                            <p className='text-danger mt-3'><b>Seminario terminato</b></p>
                        }

                        {meetingCase === 'allowed' &&
                            <Button size="lg" onClick={() => goToMeeting(data)} variant='primary'>Partecipa</Button>
                        }

                        {meetingCase != 'allowed' &&
                            <Button size="lg" disabled variant='primary'>Partecipa</Button>
                        }
                    </Container>
                ) : (
                    <></>
                )}

                <Container fluid={'md'} className='text-center' style={{ overflow: 'hidden' }}>
                    <div id="meetingSDKElement" className='mt-4'></div>
                </Container>
            </>
        );
    }
};